import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';

import logo from '../images/PINSTACK.jpeg'

import reactStringReplace from "react-string-replace";
import { Font } from '@react-pdf/renderer';
import greatVibes from '../assets/fonts/GreatVibes-Regular.ttf'; // ← Adjust path as needed
// Create styles
Font.register({
    family: 'Great Vibes',
    src: greatVibes
});
const colors = {
    dark: '#222',
    dark2: '#666',
    gray: '#e3e3e3',
    white: '#fff',
    errorRed: 'rgb(255, 220, 222)'
};
const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 15,
    },
    paragraph: {
        display: 'block',
        fontSize: 12,
        lineHeight: 1.5,
        marginBottom: 12,
    },
    initialBox: {
        display: 'inline-block',
        fontFamily: 'Great Vibes',
        fontSize: 10,
        padding: 0,
        margin: 0,
        lineHeight: 1.3,

    },
    contractTitle: {
        textAlign: 'center',
        marginBottom: 5,
    },
    contractIdBox: {
        border: '1px solid black',
        padding: 3,
        textAlign: 'center',
        width: 120,
    },
    infoSection: {
        marginBottom: 15,
    },

    infoLabel: {
        width: '25%',
        fontWeight: 'bold',
    },
    infoValue: {
        width: '25%',
    },
    pricingNote: {
        marginBottom: 15,
        fontSize: 9,
    },
    sectionHeader: {
        fontWeight: 'bold',
        textAlign: 'center',
        verticalAlign: 'middle',
        height: 35,
        backgroundColor: '#f2f2f2',
        fontSize: 25,
        borderBottom: '1px solid black',
        paddingBottom: 3,
        paddingTop: 3,
        border: '1px solid black',
    },
    itemsHeader: {
        flexDirection: 'row',
        fontWeight: 'bold',
        marginBottom: 5,
    },
    itemRow: {
        flexDirection: 'row',
        marginBottom: 5,

    },
    itemName: {
        width: '50%',
    },
    itemPrice: {
        width: '15%',
        textAlign: 'right',
    },
    itemQty: {
        width: '15%',
        textAlign: 'right',
    },
    itemTotal: {
        width: '20%',
        textAlign: 'right',
    },
    packageDetails: {
        marginLeft: 10,
        marginBottom: 5,
        border: '1px solid black',
        padding: 5,
    },
    bulletList: {
        marginLeft: 20,
        marginBottom: 5,
    },
    optionList: {
        marginLeft: 30,
        marginBottom: 5,
    },
    italicText: {
        fontStyle: 'italic',
    },
    logo: {
        width: 100,

    },
    border: {
        border: '1px solid black',
        padding: 2,
    },
    totalsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 10,
        paddingRight: 20,
    },
    totalsTable: {
        border: '1px solid #000',
        borderCollapse: 'collapse', // Note: not all CSS props are supported in react-pdf; this might not apply
        marginTop: 10,
    },
    totalsRow: {
        width: 200,
        flexDirection: 'row',
        borderBottom: '1px solid #ccc',
    },
    totalsLabel: {
        flex: 1,
        paddingTop: 6,
        paddingRight: 3,
        paddingBottom: 3,
        paddingLeft: 6,
        textAlign: 'right',
        backgroundColor: '#f2f2f2',
        borderRight: '1px solid #ccc',
    },
    totalsCell: {
        flex: 1,
        padding: 6,
        textAlign: 'right',
    },
    totalsRowTotal: {
        fontWeight: 'bold',
        backgroundColor: '#fff',
    },
    finePrint: {
        fontSize: 12,
    }, cursive: {
        fontFamily: 'Great Vibes',
        fontSize: 12,
    },
    signatureRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 12,
        marginTop: 40,
        gap: 12 // optional: improves spacing
    },
    signatureField: {
        borderBottomWidth: 1.5,
        borderBottomColor: colors.dark,
        paddingBottom: 5,
        minHeight: 25,
        justifyContent: 'flex-end'
    },
    signatureLabel: {
        fontSize: 9,
        marginTop: 3,
        textAlign: 'left'
    },
    backInitempty: {
        backgroundColor: colors.errorRed,
        padding: 5,
        width: 60
    },
    backSignempty: {
        backgroundColor: colors.errorRed
    },
    signatureLabel: {
        fontSize: 8,
        marginTop: 2
    },
    signatureValue: {
        fontSize: 11,
        fontFamily: 'Times-Roman'
    },
    inputBorderEmpty: {
        border: '2px solid red'
    },



    // Colors
    dark: {
        color: colors.dark
    },
    white: {
        color: colors.white
    },
    bgDark: {
        backgroundColor: colors.dark2
    },
    bgGray: {
        backgroundColor: colors.gray
    },

    // Layout and Spacing
    flex: {
        flexDirection: 'row',
        flex: 1
    },
    wAuto: {
        flex: 1,
        paddingRight: 8
    },
    ml30: {
        flex: 1
    },
    infoSection: {
        width: '100%',
    },
    infoRow: {


        flexDirection: 'row',
        marginBottom: 5,
    },
    minCell: {
        fontSize: 11,
        minWidth: 40
    },
    infoTitle: {
        fontWeight: 'bold',
        padding: 4,
        fontSize: 12
    },
    infoCell: {
        border: '1px solid black',
        padding: 4,
        fontSize: 11
    },
    w100: { width: '100%' },
    w85: { width: '85%' },
    w50: { width: '50%' },
    w55: { width: '55%' },
    w45: { width: '45%' },
    w60: { width: '60%' },
    w40: { width: '40%' },
    w48: { width: '48%' },
    w17: { width: '17%' },
    w15: { width: '15%' },
    w7: { width: '7%' },
    w18: { width: '18%' },
    w25: { width: '25%' },
    w10: { width: '10%' },
    w30: { width: '33%' },
    w35: { width: '35%' },
    w28: { width: '28%' },

    mt40: { marginTop: 40 },
    mt30: { marginTop: 30 },
    mt20: { marginTop: 20 },
    mt10: { marginTop: 10 },
    ms40: { marginLeft: 40 },
    ms30: { marginLeft: 30 },
    ms20: { marginLeft: 20 },
    ms10: { marginLeft: 10 },
    mk10: { marginLeft: 150 },
    mr10: { marginRight: 10 },
    ml10: { marginLeft: 10 },
    mb5: { marginBottom: 5 },
    mb0: { marginBottom: 0 },

    p48: { padding: '4px 8px' },
    p5: { padding: 5 },
    pr5: { paddingRight: 8 },
    pb10: { paddingBottom: 10 },

    // Typography
    right: { textAlign: 'right' },
    bold: { fontWeight: 'bold' },
    fs20: { fontSize: 15 },
    fs12: { fontSize: 12 },
    fs8: { fontSize: 8 },
    fs10: { fontSize: 10 },
    fs45: { fontSize: 25 },

    //   page: {
    //     fontFamily: 'Nunito',
    //     fontSize: 12,
    //     color: '#555',
    //     padding: '40px 35px'
    //   },

    span: {
        padding: '4px 12px 4px 0'
    },



    // Invoice specific
    invoiceTxt: { fontSize: 11 },
    pdfFontSize: { fontSize: 12 },
    pdfPadding: { padding: '40px 35px' },
    textStart: {
        textAlign: 'left',
        paddingLeft: 5
    },
    floatRight: { float: 'right' },
    floatEnd: { float: 'right' },
    floatleft: { textAlign: 'left' },

    invoiceLRI: {
        fontSize: 12,
        fontWeight: 'bold'
    },

    invoiceBox: {
        border: `5px solid ${colors.dark}`
    },

    invoiceBoxTitle: {
        backgroundColor: colors.dark,
        color: colors.white,
        textAlign: 'center',
        padding: '0 5px',
        height: 25
    },

    // Layout columns
    row: {
        position: 'relative',
        wordWrap: 'break-word'
    },

    col: {
        marginRight: 'auto',
        marginLeft: 'auto',
        width: '50%',
        wordWrap: 'break-word'
    },
    col1: {
        marginRight: 'auto',
        marginLeft: 'auto',
        width: '8%',
        wordWrap: 'break-word'
    }, col2: {
        marginRight: 'auto',
        marginLeft: 'auto',
        width: '16%',
        wordWrap: 'break-word'
    }, col3: {
        marginRight: 'auto',
        marginLeft: 'auto',
        width: '24%',
        wordWrap: 'break-word'
    }, col3: {
        marginRight: 'auto',
        marginLeft: 'auto',
        width: '24%',
        wordWrap: 'break-word'
    }, col4: {
        width: '25%',
        marginRight: 'auto',
        marginLeft: 'auto',
        wordWrap: 'break-word'
    }, col5: {
        width: '42%',
        marginRight: 'auto',
        marginLeft: 'auto',
        wordWrap: 'break-word'
    }, col6: {
        width: '50%',
        marginRight: 'auto',
        marginLeft: 'auto',
        wordWrap: 'break-word'
    },
    columns: {
        columnCount: 2,
        columnGap: 25,
        columnRule: '2px solid #3366FF'
    },




    // Text alignment
    textEnd: { textAlign: 'right' },
    textCenter: { textAlign: 'center' },

    borderTest: {
        border: `5px solid ${colors.gray}`,
        position: 'relative'
    },

    // Contract specific styles
    contractPage: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 792
    },
    contractHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: 20
    },
    contractLogo: {
        width: 150,
        height: 150,
        marginRight: 20
    },
    invoiceWrapper: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 792,
        position: 'relative',
        background: colors.white,
        padding: '40px 35px',
        boxShadow: '0 0 17px 0 rgba(16, 40, 73, 0.09)'
    },

});

const ContractPDF = ({ data, pdfMode, debug }) => {

    const [contract, setContract] = useState({ data });

    const [isLoading, setIsLoading] = useState(true);
    const [gotData, setGotData] = useState(false);






    useEffect(() => {
        console.log(contract.data)

        correctText(contract.data);

    }, []);

    // function correctText(contract) {

    //     // console.log('correct text')
    //     // console.log(contract)
    //     let contractObj = contract;

    //     // console.log(contractObj)
    //     // if (contractObj.ContractType === 'CE') { console.log("in testing") }
    //     if (contractObj.ContractType === 'CE') {
    //         try {
    //             // ---------------- base text ----------------
    //             let rawBottom = contractObj.ContractBottomCE ?? '';
    //             let contractTop = contractObj.ContractTopCE ?? '';

    //             // replace Location, \r, etc.
    //             let contractBottom = reactStringReplace(
    //                 rawBottom,
    //                 /(<<Location>>)/g,
    //                 (_, i) => <Text style={styles.bold} key={`loc-${i}`}>{contractObj.Location}</Text>
    //             );
    //             contractBottom = reactStringReplace(
    //                 contractBottom,
    //                 /\r/g,
    //                 (_, i) => <br key={`br-${i}`} />
    //             );

    //             // … all your other replacements on contractBottom & contractTop …

    //             // ---------------- INT placeholders ----------------
    //             const intMatches = rawBottom.match(/<<INT[0-9]+>>/g) || [];

    //             intMatches.forEach((placeholder, idx) => {
    //                 const value = contractObj[`EventsSignatures::INT${idx + 1}`] ?? '';
    //                 contractBottom = reactStringReplace(contractBottom, placeholder, () => (
    //                     <View
    //                         key={`int-${idx}`}
    //                         style={[styles.contractBottom, styles.border, styles.inputDiv]}
    //                     >
    //                         <Text style={styles.cursive}>{value}</Text>
    //                     </View>
    //                 ));
    //             });

    //             // ---------------- build array/object for PDF ----------------
    //             const rawContractBottom = contractObj.ContractBottomCE;

    //             // 🛑 Make sure this happens BEFORE any JSX replacements!
    //             const contractBottomObj = buildContractBottomArray(rawContractBottom, contractObj, styles);
    //             // const contractBottomObj = buildContractBottomArray(
    //             //     contractBottom,     // pass the *React-node* version
    //             //     contractObj,
    //             //     styles
    //             // );

    //             setContract(prev => ({
    //                 ...prev,
    //                 ...contractObj,
    //                 ContractBottom: contractBottomObj,  // now an object/array ready for PDF
    //                 ContractTop: contractTop
    //             }));
    //         } catch (err) {
    //             console.error('Error in CE parsing', err);
    //         }
    //     }
    //     else if (contractObj.ContractType === 'SE') {
    //         console.log("se contract")
    //         try {
    //             let contractBottom;
    //             // // console.log(countInt)
    //             let contractTop;

    //             contractBottom = reactStringReplace(contractObj.EventContractTextBottomSE, /(<<Location>>)/g, (match, i) => (
    //                 <strong key={i}>{contractObj.Location}</strong>
    //             ))
    //             contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
    //                 <br />)
    //             )
    //             contractTop = reactStringReplace(contractObj.EventContractTextTopSE, /(<<Guest Count>>)/g, (match, i) => (
    //                 <>{contractObj.GuestCount}</>)
    //             )
    //             contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
    //                 <>{contractObj.TotalPerGuest}</>)
    //             )
    //             contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
    //                 <strong style={{ textDecoration: 'underline' }} key={i}>{match}</strong>)
    //             )
    //             let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
    //             contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
    //                 <strong style={{ fontSize: '11px' }} key={i}>{match}</strong>)
    //             )
    //             let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
    //             contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
    //                 <Text style={{ fontSize: '10px', fontWeight: 'bold' }} key={i}>{match}</Text>)
    //             )

    //             // // console.log(contract.eventItems.length)
    //             let eventFix;
    //             for (let e = 0; e < contractObj.eventItems.length; e++) {
    //                 // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
    //                 eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
    //                     <br />)
    //                 )
    //             }

    //             let countInt = contractObj.EventContractTextBottomSE.match(/<<INT[0-9]+>>/g)
    //             for (let c = 0; c < countInt.length; c++) {

    //                 // // console.log(countInt[c])
    //                 let initV = "<<INT" + (c + 1) + ">>"
    //                 // // console.log(initV)
    //                 contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (

    //                     <div className="backInitempty inputDiv" id={c}> <Text type="text" id={c} name={initV} size="5"   ></Text></div>
    //                 )
    //                 )

    //             }
    //             // // console.log(contract)


    //             setContract({
    //                 ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
    //             });


    //             setIsLoading(false)
    //         } catch (error) {
    //             console.log(error)
    //             setGotData(false)

    //         }
    //     } else if (contractObj.ContractType === 'Birthday') {
    //         console.log("se contract")
    //         try {
    //             let contractBottom;
    //             // // console.log(countInt)
    //             let contractTop;

    //             contractBottom = reactStringReplace(contractObj.ContractBottomBirthday, /(<<Location>>)/g, (match, i) => (
    //                 <Text style={{  fontWeight: 'bold' }} key={i}>{contractObj.Location}</Text>
    //             ))
    //             contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
    //                 <br />)
    //             )
    //             contractTop = reactStringReplace(contractObj.ContractTopBirthday, /(<<Guest Count>>)/g, (match, i) => (
    //                 <>{contractObj.GuestCount}</>)
    //             )
    //             contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
    //                 <>{contractObj.TotalPerGuest}</>)
    //             )
    //             contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
    //                 <Text style={{  fontWeight: 'bold', textDecoration: 'underline' }} key={i}>{match}</Text>)
    //             )
    //             let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
    //             contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
    //                 <Text style={{ fontSize: '10px', fontWeight: 'bold' }} key={i}>{match}</Text>)
    //             )
    //             let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
    //             contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
    //                 <Text style={{ fontSize: '10px', fontWeight: 'bold' }} key={i}>{match}</Text>)
    //             )

    //             // // console.log(contract.eventItems.length)
    //             let eventFix;
    //             for (let e = 0; e < contractObj.eventItems.length; e++) {
    //                 // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
    //                 eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
    //                     <br />)
    //                 )
    //             }

    //             let countInt = contractObj.ContractBottomBirthday.match(/<<INT[0-9]+>>/g)
    //             for (let c = 0; c < countInt.length; c++) {

    //                 // // console.log(countInt[c])
    //                 let initV = "<<INT" + (c + 1) + ">>"
    //                 // // console.log(initV)
    //                 contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (

    //                     <View id={c}> <Text type="text" id={c} name={initV} size="5"  >{contractObj.initV}</Text></View>
    //                 )
    //                 )

    //             }
    //             // // console.log(contractData)


    //             setContract({
    //                 ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
    //             });


    //             setIsLoading(false)
    //         } catch (error) {
    //             // console.log(error)
    //             setGotData(false)

    //         }
    //     }



    // }


    // ─── utils/parseContractBottom.js ───────────────────────────────────────────────
    function correctText(contract) {
        // console.log('correct text')
        // console.log(contract)
        let contractObj = contract;
        //     console.log(contractObj.ContractType)
        // console.log(contractObj)

        if (contractObj.ContractType === 'CE') {
            try {
                // console.log("in trying ce")
                let contractBottom;

                let contractTop;

                contractBottom = reactStringReplace(contractObj.ContractBottomCE, /(<<Location>>)/g, (match, i) => (
                    <strong key={`location-${i}-${Math.random()}`}>{contractObj.Location}</strong>
                ))
                contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
                    <br key={`br-${i}-${Math.random()}`} />)
                )
                contractTop = reactStringReplace(contractObj.ContractTopCE, /(<<Guest Count>>)/g, (match, i) => (
                    <React.Fragment key={`guestcount-${i}-${Math.random()}`}>{contractObj.GuestCount}</React.Fragment>
                ))
                contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
                    <React.Fragment key={`totalperguest-${i}-${Math.random()}`}>{contractObj.TotalPerGuest}</React.Fragment>
                ))
                contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
                    <strong style={{ textDecoration: 'underline' }} key={`underline-${i}-${match}`}>{match}</strong>)
                )
                let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
                contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
                    <strong style={{ fontSize: '11px' }} key={`waive-${i}-${match}`}>{match}</strong>)
                )
                let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
                contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
                    <strong style={{ fontSize: '10px' }} key={`terms-${i}-${match}`}>{match}</strong>)
                )

                // console.log(contractObj.eventItems.length)
                let eventFix;
                for (let e = 0; e < contractObj.eventItems.length; e++) {
                    // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
                    eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                        <br />)
                    )
                }
                // console.log("got here");
                // if (contractObj.ContractBottomCE) {
                //     const intMatches = contractObj.ContractBottomCE.match(/<<INT[0-9]+>>/g) || [];
                //     // console.log(intMatches.length);
                //     for (let c = 0; c < intMatches.length; c++) {
                //         let initV = "<<INT" + (c + 1) + ">>";
                //         // Get the field name as used in signedData
                //         let fieldName = initV.replace("<<", "EventsSignatures::").replace(">>", "");
                //         // Check if the value is empty
                //         const isEmpty = contractObj[`EventsSignatures::INT${c + 1}`].length === 0;
                //         contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (
                //             <Text
                //                 id={`init-${c}-${i}`}
                //                 style={[styles.initialBox, styles.tomato]}
                //             >{contract[`EventsSignatures::INT${c + 1}`]}
                //             </Text>


                //         ));
                //     }
                // } else {
                //     // console.log("No ContractBottomCE found");
                // }
                // console.log(contract)


                setContract({
                    ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
                });


                setIsLoading(false)
                // console.log(isLoading)
            } catch (error) {
                // console.log(error)
                setGotData(false)

            }
        }
        else if (contractObj.ContractType === 'SE') {
            // console.log("se contract sfsaffsdfdf")
            try {
                let contractBottom;

                let contractTop;

                contractBottom = reactStringReplace(contractObj.EventContractTextBottomSE, /(<<Location>>)/g, (match, i) => (
                    <strong key={`location-${i}-${Math.random()}`}>{contractObj.Location}</strong>
                ))
                contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
                    <br key={`br-${i}-${Math.random()}`} />)
                )
                contractTop = reactStringReplace(contractObj.EventContractTextTopSE, /(<<Guest Count>>)/g, (match, i) => (
                    <React.Fragment key={`guestcount-${i}-${Math.random()}`}>{contractObj.GuestCount}</React.Fragment>
                ))
                contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
                    <React.Fragment key={`totalperguest-${i}-${Math.random()}`}>{contractObj.TotalPerGuest}</React.Fragment>
                ))
                contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
                    <strong style={{ textDecoration: 'underline' }} key={`underline-${i}-${match}`}>{match}</strong>)
                )
                let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
                contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
                    <strong style={{ fontSize: '11px' }} key={`waive-${i}-${match}`}>{match}</strong>)
                )
                let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
                contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
                    <strong style={{ fontSize: '10px' }} key={`terms-${i}-${match}`}>{match}</strong>)
                )

                // console.log(contractObj.eventItems.length)
                let eventFix;
                for (let e = 0; e < contractObj.eventItems.length; e++) {
                    // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
                    eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                        <br />)
                    )
                }
                if (contractObj.EventContractTextBottomSE) {
                    // console.log("contract se")
                    const intMatches = contractObj.EventContractTextBottomSE.match(/<<INT[0-9]+>>/g) || [];
                    // console.log(intMatches.length);
                    for (let c = 0; c < intMatches.length; c++) {
                        let initV = "<<INT" + (c + 1) + ">>";
                        // Get the field name as used in signedData
                        let fieldName = initV.replace("<<", "EventsSignatures::").replace(">>", "");
                        // Check if the value is empty
                        const isEmpty = contractObj[`EventsSignatures::INT${c + 1}`].length === 0;
                        contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (
                            <View style={{ marginTop: 20 }}>
                                {contract.ContractBottom && Object.entries(contract.ContractBottom).map(([key, line]) => {
                                    const processedLine = reactStringReplace(line, /<<INT(\d+)>>/g, (match, i) => {
                                        const fieldName = `EventsSignatures::INT${i + 1}`;
                                        const value = contract[fieldName] || '';
                                        return (
                                            <Text key={`init-${i}`} style={styles.initials}>
                                                {value}
                                            </Text>
                                        );
                                    });

                                    return (
                                        <Text key={key} style={{ marginBottom: 6 }}>
                                            {processedLine}
                                        </Text>
                                    );
                                })}
                            </View>
                        ));
                    }
                } else {
                    // console.log("No ContractBottomCE found");
                }
                // // console.log(contract)


                setContract({
                    ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
                });


                setIsLoading(false)

            } catch (error) {
                // console.log(error)
                setGotData(false)

            }
        } else if (contractObj.ContractType === 'Birthday') {
            // console.log("se contract")
            try {
                let contractBottom;

                let contractTop;
                const uniqueKey = (prefix, index) => `${prefix}-${index}-${Math.random().toString(36).substr(2, 9)}`;

                contractBottom = reactStringReplace(contractObj.ContractBottomBirthday, /(<<Location>>)/g, (match, i) => (
                    <strong key={uniqueKey('location', i)}>{contractObj.Location}</strong>
                ))
                contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
                    <br key={uniqueKey('br', i)} />)
                )
                contractTop = reactStringReplace(contractObj.ContractTopBirthday, /(<<Guest Count>>)/g, (match, i) => (
                    <React.Fragment key={uniqueKey('guestcount', i)}>{contractObj.GuestCount}</React.Fragment>
                ))
                contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
                    <React.Fragment key={uniqueKey('totalperguest', i)}>{contractObj.TotalPerGuest}</React.Fragment>
                ))
                contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
                    <strong style={{ textDecoration: 'underline' }} key={`underline-${i}-${match}`}>{match}</strong>)
                )
                let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
                contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
                    <strong style={{ fontSize: '11px' }} key={`waive-${i}-${match}`}>{match}</strong>)
                )
                let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
                contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
                    <strong style={{ fontSize: '10px' }} key={`terms-${i}-${match}`}>{match}</strong>)
                )

                // console.log(contractObj.eventItems.length)
                let eventFix;
                for (let e = 0; e < contractObj.eventItems.length; e++) {
                    // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
                    eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
                        <br />)
                    )
                }
                if (contractObj.EventContractTextBottomSE) {
                    // console.log("contract se")
                    const intMatches = contractObj.EventContractTextBottomSE.match(/<<INT[0-9]+>>/g) || [];
                    // console.log(intMatches.length);
                    for (let c = 0; c < intMatches.length; c++) {
                        let initV = "<<INT" + (c + 1) + ">>";
                        // Get the field name as used in signedData
                        let fieldName = initV.replace("<<", "EventsSignatures::").replace(">>", "");
                        // Check if the value is empty
                        const isEmpty = contractObj[`EventsSignatures::INT${c + 1}`].length === 0;
                        contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (
                            <Text
                                id={`init-${c}-${i}`}
                                style={[styles.initialBox, styles.textCenter]}
                            >{contract[`EventsSignatures::INT${c + 1}`]}</Text>


                        ));
                    }
                } else {
                    // console.log("No ContractBottomCE found");
                }

                setContract({
                    ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
                });


                setIsLoading(false)
            } catch (error) {
                // console.log(error)
                setGotData(false)

            }
            // console.log("contract bottom")
            // console.log(contractObj)
        }



    }


    /**
     * 1. receives the _raw_ CE bottom text
     * 2. injects INT values
     * 3. returns { 1: <Text …>, 2: <Text …>, … }
     */
    function buildContractBottomArray(raw, contractObj, styles) {
        if (typeof raw !== 'string') {
            // console.warn('Expected string input for buildContractBottomArray, got:', typeof raw);
            return {};
        }
        // or throw error if that's safer
        if (!raw) return { 1: <Text /> };
        // 1️⃣  inject INTx values
        let replaced = raw;
        // console.log(replaced)
        replaced = raw.replace(/(<<Location>>)/g, contractObj.Location + ' ');
        // console.log(raw)
        const intMatches = raw.match(/<<INT[0-9]+>>/g) || [];
        intMatches.forEach((token) => {
            const idx = token.match(/\d+/)[0];                       // "3"
            const value = contractObj[`EventsSignatures::INT${idx}`] || '';
            replaced = replaced.replaceAll(
                token,
                `@@INT-PLACEHOLDER-${idx}@@`                           // sentinel token
            );
        });

        // 2️⃣  split into paragraphs
        const outArray = [];
        const firstDash = replaced.indexOf('-');
        if (firstDash === -1) {
            outArray.push(replaced.trim());
        } else {
            outArray.push(replaced.slice(0, firstDash).trim());      // before first dash
            replaced
                .slice(firstDash)                                      // the bullet block
                .split(/-\s+/)                                         // split on bullets
                .filter(Boolean)
                .forEach((seg) => outArray.push('- ' + seg.trim()));
        }

        // 3️⃣  rebuild each paragraph → <Text> and restore INT nodes
        const paragraphObj = {};
        outArray.forEach((seg, i) => {
            const withIntNodes = seg.split(/@@INT-PLACEHOLDER-(\d+)@@/).map((part, j) => {
                // even indices === plain text, odd indices === INT index
                if (j % 2 === 0) return part;
                const intIdx = part;                                   // e.g. "3"
                const val = contractObj[`EventsSignatures::INT${intIdx}`] || '';
                return (
                    <View key={`int-${i}-${intIdx}`}
                        style={[styles.border, { marginLeft: 4, marginRight: 4, padding: 2 }]}>
                        <Text style={styles.cursive}>{val}</Text>
                    </View>
                );
            });

            paragraphObj[i + 1] = (
                <Text key={`p-${i}`} style={{ fontSize: 10 }}>
                    {withIntNodes}
                </Text>
            );
        });
        // console.log("paragraphObj", paragraphObj)
        return paragraphObj; // { 1: <Text …>, 2: <Text …>, … }
    }


    function convertToStandardTime(timeString) {
        const timeParts = timeString.split(":");
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);

        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(seconds);

        return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "numeric", hour12: true });
    }

    const formatParagraphText = (rawText = "", pdfMode = false) => {
        if (!rawText) return null;

        // Normalize newlines and remove null characters or extra symbols like ASCII 31
        const normalized = rawText
            .replace(/\u001f/g, '') // remove ASCII "unit separator"
            .replace(/\r\n|\r/g, '\n') // normalize line breaks
            .trim();

        const lines = normalized.split('\n').map(line => line.trim());


        return (
            <View wrap={false} style={styles.border}>
                {lines.map((line, idx) => (
                    <Text key={idx} style={[{ marginBottom: 4, color: '#f34ar' }]}>
                        {line}
                    </Text>
                ))}
            </View>
        );

    }
    function parseContractBottom(text, contractObj) {
        const result = [];
        const intRegex = /<<INT\d+>>/g;

        // Match all <<INTn>> placeholders
        const intMatches = [...text.matchAll(intRegex)];

        let lastIndex = 0;

        intMatches.forEach((match, index) => {
            const matchStart = match.index;
            const matchEnd = match.index + match[0].length;

            // Slice from last index to this <<INTn>>
            const sectionText = text.slice(lastIndex, matchStart).trim();
            const placeholder = match[0];
            const fieldKey = placeholder.replace(/<</g, 'EventsSignatures::').replace(/>>/g, '');

            // Find the first dash and separate the heading
            const dashIndex = sectionText.indexOf('-');
            const heading = dashIndex !== -1 ? sectionText.slice(0, dashIndex).trim() : '';
            const body = dashIndex !== -1 ? sectionText.slice(dashIndex).trim() : sectionText;

            result.push({
                heading,
                body,
                placeholder,
                value: contractObj[fieldKey] || ''
            });

            lastIndex = matchEnd;
        });

        // Capture any remaining text after the last INT
        const remainder = text.slice(lastIndex).trim();
        if (remainder) {
            result.push({ heading: '', body: remainder, placeholder: '', value: '' });
        }
        // console.log("result", result)
        return result;
    }


    return (

        <Document>
            <Page size="A4" style={styles.page}>
                {/* Header */}
                <View style={styles.header}>
                    <Image src={logo} style={styles.logo} />
                    <View style={styles.contractTitle}>
                        <Text style={[styles.contractTitle, styles.bold]}>
                            Sales / Catering Contract
                        </Text>
                        <Text style={styles.contractTitle}>{contract.Location} Location</Text>
                        <View style={styles.contractIdBox}>
                            <Text>{data['__PK_BEO_ID']}</Text>
                        </View>
                    </View>
                </View>

                {/* Client Info */}
                <View style={styles.infoSection}>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoLabel, styles.bold]}>Client Organization</Text>
                        <Text style={[styles.infoLabel, styles.bold]}>Event Date</Text>
                        <Text style={[styles.infoLabel, styles.bold]}>Phone</Text>
                        <Text style={[styles.infoLabel, styles.bold]}>Email</Text>
                    </View>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoValue, styles.border]}>{contract.Client_Organization}</Text>
                        <Text style={[styles.infoValue, styles.border]}>{contract.EventDate}</Text>
                        <Text style={[styles.infoValue, styles.border]}>{contract.BookingContactPhone}</Text>
                        <Text style={[styles.infoValue, styles.border]}>{contract.BookingContactEmail}</Text>
                    </View>
                </View>

                <View style={styles.infoSection}>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoLabel, styles.bold]}>Address</Text>
                        <Text style={[styles.infoLabel, styles.bold]}>Booking Contact</Text>
                        <Text style={[styles.infoLabel, styles.bold]}>Site Contact</Text>
                        <Text style={[styles.infoLabel, styles.bold]}>Guest</Text>
                    </View>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoValue, styles.border]}>{contract.BillingAddress}</Text>
                        <Text style={[styles.infoValue, styles.border]}>{contract.BookingContactFullName}</Text>
                        <Text style={[styles.infoValue, styles.border]}>{contract.SiteContactFullName}</Text>
                        <Text style={[styles.infoValue, styles.border]}>{contract.GuestCount}</Text>
                    </View>
                </View>

                <Text style={[styles.pricingNote, styles.fs10]}>
                    PRICING BASED ON MINIMUM GUARANTEED GUEST COUNT OF {contract.GuestCount}. ESTIMATED COST PER GUEST {contract.TotalPerGuest}. ANY CHANGES TO
                    GUARANTEED GUEST COUNT MUST BE MADE NO LATER THAN 7 DAYS BEFORE EVENT DATE. CANCELLATION CHARGES MAY APPLY.
                </Text>

                {/* Event Items */}

                <Text style={[styles.sectionHeader, styles.bold]}>Event Items</Text>

                <View style={[styles.itemsHeader]}>
                    <Text style={styles.itemName}>Food/Service Items</Text>
                    <Text style={styles.itemPrice}>Price</Text>
                    <Text style={styles.itemQty}>Qty</Text>
                    <Text style={styles.itemTotal}>Total</Text>
                </View>

                {contract.eventItems?.map((item, index) => (
                    <React.Fragment key={index}>
                        <View wrap={false} style={styles.itemRow}>
                            <Text style={styles.itemName}>{item["Event Food Items::Display"]}</Text>
                            <Text style={styles.itemPrice}>{item["Event Food Items::Item PriceUpdated"]}</Text>
                            <Text style={styles.itemQty}>{item["Event Food Items::ItemQty"]}</Text>
                            <Text style={styles.itemTotal}>{item["Event Food Items::Line Total"]}</Text>
                        </View>

                        {formatParagraphText(item["Event Food Items::Item Name Description"])}

                    </React.Fragment>
                ))}

                {/* Event Space */}
                {contract.resouceItems?.length > 0 && (
                    <View>
                        <View style={[styles.eventContainer, styles.border, styles.bgGray]}>
                            <View style={styles.textCenter}>
                                <Text style={[styles.fs45, styles.bold]}>Event Space</Text>
                            </View>
                        </View>
                        <View style={[, styles.itemsHeader]}>
                            <Text style={styles.col3}>Event Space</Text>
                            <Text style={[styles.col2, styles.textCenter]}>Start</Text>
                            <Text style={styles.col1}>Bar</Text>
                            <Text style={[styles.col1, styles.textCenter]}>Serving</Text>
                            <Text style={[styles.col2, styles.textCenter]}>End</Text>
                            <Text style={styles.col2}>Set Up Style</Text>
                        </View>

                        {contract.resouceItems.map((reso, idx) => (
                            <View key={idx}>
                                <View style={[styles.infoRow, styles.itemsRow]}>
                                    <Text style={styles.col4}>{reso["Event Resources::ItemName"]}</Text>
                                    <Text style={[styles.col2, styles.textCenter]}>{convertToStandardTime(reso["Event Resources::starting_time"])}</Text>
                                    <Text style={[styles.col1, styles.textCenter]}>{reso["Event Resources::Bar"]}</Text>
                                    <Text style={[styles.col1, styles.textCenter]}>{reso["Event Resources::Serving"]}</Text>
                                    <Text style={[styles.col2, styles.textCenter]}>{convertToStandardTime(reso["Event Resources::ending_time"])}</Text>
                                    <Text style={[styles.col2, styles.textCenter]}>{reso["Event Resources::SetupStyle"]}</Text>
                                </View>
                                <View style={[styles.itemDescription, styles.border, styles.fs10]}>
                                    <Text>{reso["Event Food Items::Item Name Description"]}</Text>
                                </View>
                            </View>
                        ))}
                    </View>
                )}
                {/* Comments */}
                <View style={[styles.eventContainer, styles.border, styles.bgGray]}>
                    <View style={styles.textCenter}>
                        <Text style={[styles.fs45, styles.bold]}>Comments</Text>
                    </View>
                </View>

                <View style={styles.fs12}>
                    <Text>{contract.Comments}</Text>
                </View>
                {/* Totals */}
                <View style={styles.totalsContainer}>
                    <View style={styles.totalsTable}>
                        <View style={styles.totalsRow}>
                            <Text style={styles.totalsLabel}>SubTotal</Text>
                            <Text style={styles.totalsCell}>${Number(contract.LineTotal).toFixed(2)}</Text>
                        </View>
                        <View style={styles.totalsRow}>
                            <Text style={styles.totalsLabel}>Service Fee</Text>
                            <Text style={styles.totalsCell}>${Number(contract.ServiceFeeTotal).toFixed(2)}</Text>
                        </View>
                        <View style={styles.totalsRow}>
                            <Text style={styles.totalsLabel}>Tax</Text>
                            <Text style={styles.totalsCell}>${Number(contract.TaxTotal).toFixed(2)}</Text>
                        </View>
                        <View style={[styles.totalsRow, styles.totalsRowTotal]}>
                            <Text style={styles.totalsLabel}>Total</Text>
                            <Text style={styles.totalsCell}>${Number(contract.Total).toFixed(2)}</Text>
                        </View>
                    </View>
                </View>
                {/* Contract Bottom Text */}
                {/* <View style={{ marginTop: 20 }}>
                    {Array.isArray(contract.ContractBottom) ? (
                        contract.ContractBottom.map((line, i) => (
                            <View key={`line-${i}`} style={{ marginBottom: 8 }}>
                                {typeof line === 'string' ? (
                                    <Text>{line}</Text>
                                ) : (
                                    <Text>{line?.props?.children || ''}</Text> // safe fallback
                                )}
                            </View>
                        ))
                    ) : (
                        <Text>{contract.ContractBottom}</Text>
                    )}
                </View> */}
                {/*   the previous working section for initails       */}
                {/* <View style={{ marginTop: 20 }}>
                    {contract.ContractBottom && Object.entries(contract.ContractBottom).map(([key, line]) => (
                        <View key={key} style={{ marginBottom: 6 }}>
                            <Text>{line}</Text>
                        </View>
                    ))}
                </View> */}


    <View style={{ marginTop: 20 }}>
  {contract.ContractBottom && Object.entries(contract.ContractBottom).map(([key, line]) => {
    const parts = reactStringReplace(line, /<<INT(\d+)>>/g, (match, i) => {
      const intIndex = match.match(/\d+/)[0];
      const value = contract[`EventsSignatures::INT${intIndex}`] || '___';
      return (
        <Text key={`int-${key}-${i}`} style={styles.initialBox}>
          {value}
        </Text>
      );
    });

    return (
      <Text key={key} style={{ marginBottom: 6 }}>
        {/* This will output a single <Text> node with mixed content */}
        {parts}
      </Text>
    );
  })}
</View>

                {/* Signature Section */}
                {/* <View style={[styles.signatureRow]}>
                    <View style={[styles.w25, styles.col4]}>
                        <View style={styles.signatureField}>
                            <Text style={styles.signatureValue}>
                                {contract.signatureText || ''}
                            </Text>
                        </View>
                        <Text style={styles.signatureLabel}>Event Contact Signature</Text>
                    </View>

                    <View style={[styles.w25, styles.col4]}>
                        <View style={styles.signatureField}>
                            <Text style={styles.signatureValue}>
                                {contract.ContractSignDate || ''}
                            </Text>
                        </View>
                        <Text style={styles.signatureLabel}>Date</Text>
                    </View>

                    <View style={[styles.w25, styles.col4]}>
                        <View style={styles.signatureField}>
                            <Text style={styles.signatureValue}>
                                {contract.signatureText || ''}
                            </Text>
                        </View>
                        <Text style={styles.signatureLabel}>Print Name</Text>
                    </View>
                </View> */}
                <View style={[styles.infoSection, styles.mb5]}>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoValue, styles.w30, styles.cursive]}>{contract.SignatureText}</Text>
                        <Text style={[styles.infoValue, styles.w30]}>{contract.EventDate}</Text>
                        <Text style={[styles.infoValue, styles.w30]}>{contract.BookingContactEmail}</Text>
                    </View>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoLabel, styles.bold, styles.w30, { borderTop: '2px', padding: 2 }]}>Event Contact Signature</Text>
                        <Text style={[styles.infoLabel, styles.bold, styles.w30, { borderTop: '2px', padding: 2 }]}>Date</Text>
                        <Text style={[styles.infoLabel, styles.bold, styles.w30, { borderTop: '2px', padding: 2 }]}>Print name</Text>

                    </View>

                </View>
                <View style={[styles.infoSection]}>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoValue, styles.w45, styles.col6]}>{contract.Client_Organization}</Text>
                        <Text style={[styles.infoValue, styles.w45, styles.col6]}>{contract.EventDate}</Text>

                    </View>
                    <View style={styles.infoRow}>
                        <Text style={[styles.infoLabel, styles.bold, styles.w45, styles.col6, { borderTop: '2px', padding: 2 }]}>Business Name</Text>
                        <Text style={[styles.infoLabel, styles.bold, styles.w45, styles.col6, { borderTop: '2px', padding: 2 }]}>Date / Time of Event</Text>


                    </View>

                </View>
                <View style={[styles.infoRow, styles.mt30]}>
                    <View style={styles.w35}>
                        <Text style={[styles.infoLabel, styles.w85, styles.bold, { padding: 2 }]}>Billing Address: </Text>
                        <Text style={[styles.w85, styles.bold, { padding: 2 }]}>    6205 Dallas Parkway
                            Plano, TX 75024</Text>

                    </View>
                    <View style={styles.w35}>
                        <Text style={[styles.infoLabel, styles.w85, styles.bold, { padding: 2 }]}>Pin Stack  </Text>
                        <Text style={[styles.w85, styles.bold, { padding: 2 }]}>    6205 Dallas Parkway
                            Plano, TX 75024</Text>

                    </View>
                    <View style={styles.w35}>
                        <Text style={[styles.infoLabel, styles.w85, styles.bold, { padding: 2 }]}>{contract.SiteContactFullName} </Text>
                        <Text style={[styles.w85, styles.bold, { padding: 2 }]}>{new Date().toLocaleString()}</Text>

                    </View>


                </View>

            </Page>
        </Document>
    );
};

export default ContractPDF;